import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { renderDisabledStatus, renderEnabledStatus } from '../../utils/common';
import { SIMPLE_DATETIME_FORMAT } from '../../config/app_config';

export default class Datasets extends React.Component {
  static propTypes = {
    dataSets: PropTypes.object.isRequired,
  };

  renderDatasetRows = (d, idx) => (
    <tr key={idx}>
      <td>{d.name}</td>
      <td>
        <p>{d.status === 0 ? renderDisabledStatus() : renderEnabledStatus()}</p>
      </td>
      <td>{moment(d.createdOn).format(SIMPLE_DATETIME_FORMAT)}</td>
      <td>{moment(d.updatedOn).format(SIMPLE_DATETIME_FORMAT)}</td>
      <td>
        <Link className="btn btn-sm btn-primary-outline" to={`/data/dataset/${d.id}`}>
          Detail
        </Link>
      </td>
    </tr>
  );
  render() {
    const { dataSets } = this.props;
    return (
      <div className="row">
        <div className="col-md-12">
          {dataSets === undefined || dataSets.length === 0 ? (
            <p>There are no Datasets currently associated with this account.</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Dataset Name</th>
                  <th>Status</th>
                  <th>Created On</th>
                  <th>Updated On</th>
                  <th>Detail</th>
                </tr>
              </thead>
              <tbody>{dataSets.valueSeq().map(this.renderDatasetRows)}</tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}
